import React from 'react';
import './DeleteAccount.css';

const steps = [
  {
    number: 1,
    title: 'Login to your account',
    description: 'Access your account by entering your credentials on the login page.'
  },
  {
    number: 2,
    title: 'Navigate to User Settings',
    description: 'Click on the user icon button located in the top-left corner of the screen.'
  },
  {
    number: 3,
    title: 'Find Delete Account Option',
    description: 'Scroll down through the settings menu until you locate the "Delete Account" option.'
  },
  {
    number: 4,
    title: 'Confirm Account Deletion',
    description: 'Click on "Delete Account" and then press "Delete" to permanently remove your account and all associated data.'
  }
];

export default function DeleteAccount() {
  return (
    <div className="delete-account-container">
      <div className="delete-account-card">
        <h1>Delete Account</h1>
        <h2>How to Delete Your Account</h2>
        <p>
          If you wish to permanently delete your account and remove all your data from our platform, 
          please follow the steps below. Please note that this action is irreversible and will permanently 
          delete all your information, preferences, and account history.
        </p>
        <div className="warning-box">
          <strong>⚠️ Important:</strong> Account deletion is permanent and cannot be undone. 
          Make sure you have backed up any important information before proceeding.
        </div>
      </div>
      <div className="delete-account-steps-section">
        <h3>Step-by-Step Instructions</h3>
        <div className="steps-container">
          {steps.map((step) => (
            <div key={step.number} className="step-item">
              <div className="step-number">{step.number}</div>
              <div className="step-content">
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="contact-info">
          <h3>Need Help?</h3>
          <p>
            If you encounter any issues during the account deletion process or have questions, 
            please contact our support team at <strong>support@k2neet.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
} 